// src/layouts/AppLayout.jsx
import { useState } from 'react';
import { Box, CssBaseline } from '@mui/material';
import Sidebar from '../components/Sidebar';

const DRAWER_WIDTH = 240;   // Sidebar 와 동일

export default function AppLayout({ children }) {
    /* Sidebar 상태를 부모(레이아웃)가 관리 */
    const [openPC, setOpenPC] = useState(true);

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />

            {/* ───── Sidebar ───── */}
            <Sidebar
                showHamburger
                openExternal={openPC}
                setOpenExternal={setOpenPC}
            />

            {/* ───── Main content ───── */}
            <Box
                component="main"
                sx={theme => ({
                    flexGrow: 1,
                    p: { xs: 1, sm: 3 },
                    bgcolor: '#f5f5f5',
                    minHeight: '100vh',
                    transition: theme.transitions.create('margin', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    }),
                    marginLeft: openPC ? `${DRAWER_WIDTH}px` : 0,
                    [theme.breakpoints.down('sm')]: { marginLeft: 0 },
                })}
            >
                {children}
            </Box>
        </Box>
    );
}
